export default "__VITE_ASSET__GOnPwH6X__"